var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"google-map-container"},[_c('div',{ref:"map",staticClass:"google-map"}),_vm._v(" "),(_vm.status === 'map-ready')?_vm._t("default",null,{"map":_vm.googleMap}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }